export default {"src":"/_next/static/media/cash_icon.93a020f5.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};